// extracted by mini-css-extract-plugin
module.exports = {"badge":"MultipleCustomersList_badge__CqQJ3","icon":"MultipleCustomersList_icon__V9L99","linkList":"MultipleCustomersList_linkList__yUotu"};